import Header from "Dashboard/components/Header";
import { CarnetsStatistics } from "./components/CarnetsStatistics";
import { CompanyStatistics } from "./components/CompanyStatistics";
import { ResourcesStatistics } from "./components/ResourcesStatistics";
import { CreditsStatistics } from "./components/CreditsStatistics";
import { FinancialStatistics } from "./components/FinancialStatistics";
import { KvackicaStatistics } from "./components/KvackicaStatistics";
import { NonProjectsStatistics } from "./components/NonProjectsStatistics";
import { ProjectsStatistics } from "./components/ProjectsStatistics";
import { RightSection } from "./components/RightSection";
import { SalariesStatistics } from "./components/SalariesStatistics";
import Toolbox from "./components/Toolbox";

const Index = () => {
  return (
    <section className="statistics-section">
      <Header title="Statistika" />
      <Toolbox />
      <div className="statistics-mainDiv border-top">
        <div className="statistics-left">
          <ProjectsStatistics type="construction" />
          <ProjectsStatistics type="other" />
          <NonProjectsStatistics />
          <ResourcesStatistics />
          <CarnetsStatistics />
          <SalariesStatistics />
          <CompanyStatistics />
          <CreditsStatistics />
          <FinancialStatistics />
          <KvackicaStatistics />
        </div>
        <div className="statistics-right">
          <RightSection />
        </div>
      </div>
    </section>
  );
};

export default Index;
